<template>
  <div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "homeMiddleware",
  async beforeRouteEnter(to, from, next) {
    if (localStorage.lastSelectCompany) {
      let lastSelectCompany = JSON.parse(localStorage.getItem("lastSelectCompany"))
      if (lastSelectCompany.role && lastSelectCompany.role.name === '译员') {
        next(vm=>{
            vm.$router.push({ path: "/home/myTask", })
        })
      } else {
        next(vm=>{
            vm.$router.push({ path: "/home/projectHome", })
        })
      }
    } else {
      next({ path: "/home/projectHome"})
    }

  },
  data() {
    return {

    }
  },
}
</script>